import React from "react";
import { SmartTextField } from "../core/SmartTextField";

/**
 * @param {object} props
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.helperText]
 * @param {string} [props.helperText2]
 */
export const MetadataEnumTypesField = ({
  value,
  onChange,
  helperText = "Comma-separated choices, e.g. Swimmer Won, On Boat Won, Captain Won",
  helperText2 = "Comma-separated choices, e.g. Swimmer Won, On Boat Won, Captain Won",
}) => {
  return (
    <SmartTextField
      id="metadata-enum-types"
      label="Choices"
      initialValue={value}
      onChange={onChange}
      multiline
      helperText={helperText}
      helperText2={helperText2}
    />
  );
};
